import 'css-chunksrc/client/scenes/taskStatusRemoval/styles.scss';export default {
  "header": "_header_l25ow_1",
  "warning": "_warning_l25ow_5",
  "group": "_group_l25ow_11",
  "toggle": "_toggle_l25ow_24",
  "text": "_text_l25ow_37",
  "name": "_name_l25ow_42",
  "main": "_main_l25ow_48",
  "content": "_content_l25ow_55",
  "buttons": "_buttons_l25ow_62",
  "transferIcon": "_transferIcon_l25ow_72",
  "status": "_status_l25ow_77"
};